const accordionList = [
    {
        title: "Highly Experienced Team",
        content: "Our research team has more than 150 years of experience; and in-depth healthcare knowledge and experience, they are key to unlocking complex problems and know exactly how to deliver the best",
        link: "/report-store.php",
    },
    {
        title: "Timely Intelligence",
        content: "Time is of the essence in the dynamism of the healthcare competitive intelligence industry, and our experts provide you with real-time insights into the market strategy, regulatory evolution, and myriad healthcare challenges.",
        link: "/request-for-proposal",
    },
    {
        title: "Post-sales Analyst Support",
        content: "We have a highly dedicated team of analysts and consultants who are equipped to provide you with long-term support, even after final project delivery, ensuring client satisfaction and delight",
        link: "/consulting/competitive-intelligence-services",
    },
];
const interactionsList = [
    {
        title: "KOL Interactions",
        description: "DelveInsight’s dedicated KOL network ensures you receive accurate insights on the industry experts&#39; thinking",
        imageSrc: "/assets/images/cipage/kol-lnteractions.png",
        altText: "KOL Interactions",
        link: "/blog/competitive-intelligence-in-healthcare-sector",
    },
    {
        title: "Navigating Health 4.0",
        description: "Highly able to tackle new-age healthcare problems surrounding the application of digital therapy and Artificial Intelligence.",
        imageSrc: "/assets/images/cipage/navigating-health-4.0.png",
        altText: "Navigating Health 4.0",
        link: "/blog/competitive-intelligence-in-healthcare-sector",
    },
    {
        title: "Agile Methodology",
        description: "An intelligent mix of secondary and research methodologies aims for effective insights generation.",
        imageSrc: "/assets/images/cipage/agile-methodology.png",
        altText: "Agile Methodology",
        link: "/blog/competitive-intelligence-in-healthcare-sector",
    },
    {
        title: "Customized Solutions",
        description: "Supporting each client partner with modern-day solutions to their unique problems.",
        imageSrc: "/assets/images/cipage/customized-solutions.png",
        altText: "Customized Solutions",
        link: "/blog/competitive-intelligence-in-healthcare-sector",
    },
];
const caseStudiesList = [
    {
        title: "Case Studies",
        listItem: [
            {
                title: "Out-Licensing Opportunity",
                description: "Licensing Partners Identification for client’s proprietary technology based neonatal MSCsOpportunity Assessment through Secondary & Primary Intelligence.",
                imageSrc: "/assets/images/cipage/Out-Licensing-Opportunity.jpg",
                link: "/case-study/out-licensing-opportunity",
                altText: "Out-Licensing Opportunity",
            },
            {
                title: "CDMO Competitive Assessment in USA and Europe",
                description: "A CDMO client based in Europe, involved DelveInsight to provide in-depth competitor assessment of companies active in the pharma CDMO area, in order to understand effective landscaping and conduct strategic decision-making for gaining competitive advantage. The client wanted to expand their geographical scope and improve its product portfolio, for which they also requested competitive benchmarking outcomes  from DelveInsight.",
                imageSrc: "/assets/images/cipage/CDMO-Competitive-Assessment-in-USA-and-Europe.jpg",
                link: "/case-study/cdmo-competitive-assessment",
                altText: "CDMO Competitive Assessment in USA and Europe",
            },
            {
                title: "Newsletter-based Competitive Intelligence Trackin0067",
                description: "A global pharmaceutical company wanted a dashboard for their top executive to track the evolving Competitive Intelligence landscape. The client requested DelveInsight to provide their top executives with a web-based, robust and simplified, user-friendly interactive dashboard to track key insights and trends from the competitive landscape.",
                imageSrc: "/assets/images/cipage/Newsletter-based-Competitive-Intelligence-Trackin0067.jpg",
                link: "/case-study/competitive-intelligence",
                altText: "Newsletter-based Competitive Intelligence Trackin0067",
            },
            {
                title: "In-Vitro Diagnostics competitor Due Diligence",
                description: "A mid-sized EU-based firm involved DelveInsight in assessing the approach to R&D and new product development process for two key competitors in Europe. The client made DelveInsight collect insights about how they can improve their efficiency in new product development by accessing the competitor’s R&D Structure, Regulatory Structure and Marketing Strategies.",
                imageSrc: "/assets/images/cipage/In-Vitro-Diagnostics-competitor-Due-Diligence.jpg",
                link: "/case-study/due-diligence",
                altText: "In-Vitro Diagnostics competitor Due Diligence",
            },
        ]
    }
];
const ourValueList = [
    {
        title: "Real-time Intelligence",
        description: "Providing the most updated and accurate information across pharmaceutical competitive intelligence, life science, and medical diagnostics space. Our research methodologies are robust enough to tackle complex problems to provide valuable insights.",
    },
    {
        title: "Actionable Insights",
        description: "DelveInsight’s consultants deliver high-value strategic insights through our intelligence processes to support clients’ most pressing business decisions. Delivering healthcare competitive intelligence services to create competitive advantage is our forte.",
    },
    {
        title: "100+ Years of Experience",
        description: "Our experts have proven mettle in the healthcare competitive intelligence industry through their years of research experience, which is time and again validated via their consistently exceptional feedback from clients across the globe.",
    },
];
const tabList = [
    {
        title: "Real-time Intelligence",
        description: "Staying on top of the happenings of the healthcare competitive intelligence industry has never been this important, and DelveInsight understands the necessity of being aware of each occurrence or event that might be important in an industrial space.",
        imageSrc: "/assets/images/cipage/real-time-intelligence.svg",
        points: [
            {
                title: "Customized Research",
                description: "Supported by an expert team, DelveInsight takes it upon itself to provide its partners with the very best and most accurate intelligence that can be gathered."
            },
            {
                title: "Robust and Ethical Primary Data Collection",
                description: "Reinforced by a fundamental goal of securing the best-in-class intelligence and providing analysis and insights that result in the significant success of our client partners."
            },
            {
                title: "Real-time and Actionable Primary Research Insights",
                description: "Intelligence-driven primary research addresses business queries via various research tools, gathering quantitative and qualitative information to support a hypothesis and validate decisions."
            },
        ]
    },
    {
        title: "Congress Intelligence",
        description: "Tactical Pharmaceutical Competitive Intelligence is a proven way of keeping your business perspective informed and up-to-date...",
        imageSrc: "/assets/images/cipage/Conference.svg",
        points: [
            {
                title: "Therapy-specific Conferences",
                description: "We cover and provide pre- and post-event coverage of all the major conferences happening across the globe, ranging from oncology to respiratory and MedTech."
            },
            {
                title: "Competitive Intelligence-specific Conference",
                description: "We are a regular attendee and exhibitor in the Healthcare Competitive Intelligence-based conferences, such as Pharma CI, where we interact with our clients and discuss their business solutions."
            },
            {
                title: "Partnering Conferences",
                description: "Building a robust network of clients and companies alike, DelveInsight attends, exhibits, and interacts with peers across the globe to remain relevant to our client partners and their business needs."
            },
        ]
    },
    {
        title: "Key Competitor Tracking",
        description: "Analyzing market sentiments by assessing competitor dynamics through competitive intelligence aimed to leverage the client’s portfolio.",
        imageSrc: "/assets/images/cipage/tracking.svg",
        points: [
            {
                title: "Landscape Monitoring",
                description: "Delivering insights across indications, therapies, and devices to stay well-informed of the dynamism of the healthcare sector."
            },
            {
                title: "Tracking Market Evolution",
                description: "Advising variations in the portfolio via well-informed decision-making capacity gained through a deep understanding of factorial market changes for better performance."
            },
            {
                title: "Building Strategies",
                description: "DelveInsight supports the implementation of plans and goals through a strategic eye with its competitive intelligence support by reviewing and assessing the most profitable strategic path."
            },
        ]
    },
    {
        title: "Competitive Landscape",
        description: "Providing companies with much-needed targeted information to develop business acumen and support developmental strategies to overcome industry-specific challenges.",
        imageSrc: "/assets/images/cipage/compititive-landscape.svg",
        points: [
            {
                title: "Life Cycle Management",
                description: "DelveInsight effectively assesses the client’s assets to create a novel path for sustained business excellence."
            },
            {
                title: "Attribute Analysis",
                description: "Creating effective benchmarks after tracking and positioning to provide an understanding of inherent weaknesses and unknown threats for any business"
            },
            {
                title: "Competitive Benchmarking",
                description: "Understanding of the best strategy that can be adopted by tracking the competitor’s activities and implementing technical and cost-effective transformation processes."
            },
        ]
    },
    {
        title: "Clinical Trial Pipeline Analysis",
        description: "Evaluate the best strategic route for your therapy development goals, such as making sure investments, fashioning innovative R&D, and creating a smooth developmental process",
        imageSrc: "/assets/images/cipage/clicnical-trial.svg",
        points: [
            {
                title: "Developmental Pipeline Insights",
                description: "Gather intelligence around the latest novel therapies being developed for a particular indication, mechanism of action, or therapy type from discovery to pre-registration."
            },
            {
                title: "Clinical Trial Monitoring",
                description: "Get the latest clinical research highlights to your mailbox containing intelligent insights around trial design, study arms, clinical trial criteria, and other relevant details."
            },
            {
                title: "Technology Analysis",
                description: "Track novel technology platforms to push your assets toward their developmental goals."
            },
        ]
    },
    // Add more tab items as needed
];
const contactList = {
    title: "We believe that each partner we have on our journey to provide the best competitive intelligence consulting advice and perspectives is special and unique, and so are their business and competitive intelligence consulting goals. This is why our company is dedicated to providing 100% customizable solutions.",
    imageSrc: "img/consulting/jpg/service/contactList.png",

    altText: "Healthcare Congress Business Strategie",
    points: [
        {
            title: "Receiving insights that are relevant to you",
        },
        {
            title: "Achieving fully customized project detailing solutions based on needs",
        },
        {
            title: "Two-way engagement to ensure positive and significant results",
        },
        {
            title: "Benefitting through the achievement of your competitive vision",
        },
        {
            title: "Adding value to you and your organization",
        },
    ]
};
const newsLetterList = {
    title: "Are Ready to Elevate Your Healthcare Strategy? Connect with Our Expert Consultants for Customized Solutions!",
    buttonTitle: "Connect Now",
    link: "/request-for-proposal",
};
const ctaBanner = 
{
    title: "Stay ahead with exclusive ATS conference insights—reach out to us now!",
    buttonTitle: "Connect Here",
    link: "/request-for-proposal",
};
const ctaBanner2 = 
{
    title: "Get in touch with us today to learn how we can provide ATS coverage exclusively for you!",
    buttonTitle: "Schedule a Meeting Now",
    link: "/request-for-proposal",
};

export {
    accordionList,
    interactionsList,
    caseStudiesList,
    ourValueList,
    tabList,
    contactList,
    newsLetterList,
    ctaBanner,
    ctaBanner2,
}